import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

export class DefaultDateBehavior implements IHisInfoItemBehavior {
  constructor(private _key: string, private _dateFormat?: string) {}

  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values =  hisInfoItems.filter(x => x.name === this._key).map(x => x.value);
    const dateValues = values
      .filter(x => !DateTimeStringUtility.isEmptyDate(x))
      .filter(x => DateTimeStringUtility.isDateFormat(x))
      .map(x => DateTimeStringUtility.toDateValue(x));
    return new HisInformationDateTimeValue(this._key, dateValues, this._dateFormat);
  }
}
